module.exports = __webpack_public_path__ + "img/about_tit.9f570dda.jpg";